
  import { defineComponent } from 'vue';
  import { Button } from '@/ui/components/Button';

  interface FilterSidebarActionsProps {
    disableAll: boolean;
  }

  export default defineComponent<FilterSidebarActionsProps>({
    components: {
      Button,
    },
    props: ['disableAll'],
  });
